
export default [{
	path: '/productsgroups',
	component: () => import('@/components/productsgroups/List')
}]
